import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import { message } from '../../../utils/stringUtils';

import styles from './styles';

const UTSwitch = ({ value, withLabel, onClick, style }) => (
  <div style={[style, styles.container]}>
    <div
      style={[styles.switchWrapper, value ? styles.containerActive : styles.containerInactive]}
      onClick={onClick}
      role="presentation"
    >
      <div style={[styles.switch, value ? styles.switchActive : styles.switchInactive]} />
    </div>
    {withLabel && (
      <UTLabel extrabold style={styles.switchText}>
        {value ? message('Translation:yes') : message('Translation:no')}
      </UTLabel>
    )}
  </div>
);

UTSwitch.propTypes = {
  value: PropTypes.bool.isRequired,
  withLabel: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

export default Radium(UTSwitch);
